import TruckBaseController from '../common/truck.base.controller'
import AppConstants from '../../../config/app.constants'

class TruckEditController extends TruckBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, TruckService, Modal, $translate, $stateParams, LocationService, VehicleLockerService, CommonLayoutService) {
		super(Auth, $state, User, TruckService, Modal, $translate, $stateParams)
		this.LocationService = LocationService;
		this.VehicleLockerService = VehicleLockerService;
		this.CommonLayoutService = CommonLayoutService;
		this.defaultModel = {
			id: '',
			locationId: '',
			make: '',
			status: true,
			model: '',
			year: '',
			vinnum: '',
			platenum: '',
			lockers: false,
			liability: false,
			liabilityLimit: null,
			truckLiability: false,
			NFCScan: false,
			NFCTagId: null,
			fuelType: null
		}
		this.model = angular.copy(this.defaultModel)
		this.pageName = `truck`
		this.locationList = [];
		this.totalRecord = '';
		this.branch = User.getUser().branchId
		this.locationsToIgnore = [];
		this.allTrucks = [];
		this.offset = 0;
		this.changeOffsetFlag = false;
		this.locations = [];
		this.loading = false;
		this.isValid = true;
		this.lockerLocations = [];
		this.totalLocations = 0;
		this.itemsToDelete = [];
		this.defaultLockers = [];
		this.locationIds = [];
		this.stateList = this.CommonLayoutService.locationStateMapping();
		this.fuelTypeList = this.CommonLayoutService.fuelTypeMapping();
	}

	$onInit() {
		this.Service.get(this.$stateParams.id)
			.then((data) => {
				this.defaultModel = data;
				this.model = angular.copy(this.defaultModel);
				this.rawId = data.id;
				this.model.id = data.id;
				this.model.status = data.status;
				this.model.make = data.make;
				this.model.model = data.model;
				this.model.year = data.year;
				this.model.vinnum = data.vinnum;
				this.model.platenum = data.platenum;
				this.model.truckLockers = data.truckLockers;
				this.model.liability = data.liability;
				this.model.liabilityLimit = data.liabilityLimit;
				this.model.truckLiability = data.truckLiability;
				this.locationIds = this.model.truckLockers.map(d => d.locationId);
				if (data.location) {
					data.location.Key = data.location.id + " | " + data.location.name;
					data.location.Value = data.location.id;
					data.location.address = data.location.address ? data.location.address : '';
					data.location.city = data.location.city ? data.location.city : '';
					data.location.state = data.location.state ? this.stateList[data.location.state] : '';
					data.location.zip = data.location.zip ? data.location.zip : '';
				}
				this.model.locationId = data.location;
				this.model.NFCScan = data.NFCScan;
				this.model.NFCTagId = data.NFCTagId;
				this.model.fuelType = data.fuelType;
			})
			.then(() => {
				this.getAllLocation();
				this.lockerInfo().then(() => this.validateLocker());
			})
			.catch((err) => {
				console.error(err);
				this.errorMessage = err.data.message;
			})
	}

	// get all location
	getAllLocation() {
		this.locations = [];
		this.Service.loadRemainingTrucks(this.branch, 'TRUCK')
			.then((res) => {
				this.totalRecord = res.length + 1;
				const locations = this.mappingLocationData(res);
				this.locations = this.locations.concat(locations);
				if (this.model.locationId) {
					this.locations.unshift(this.model.locationId);
				}
			})
			.catch((err) => {
				console.log(err);
			})
	}

	mappingLocationData(location) {
		return location.map((loc) => {
			return {
				Key: loc.id + " | " + loc.name,
				Value: loc.id,
				address: loc.address ? loc.address : '',
				city: loc.city ? loc.city : '',
				state: loc.state ? this.stateList[loc.state] : '',
				zip: loc.zip ? loc.zip : ''
			}
		});
	}

	reset() {
		this.model = angular.copy(this.defaultModel);
		this.model.locationId = this.defaultModel.location;
		this.itemsToDelete = [];
		if (this.model.truckLockers.length) {
			this.model.truckLockers.forEach((data, index) => {
				if (!data.id) this.model.truckLockers.splice(index, 1);
			})
		}
		this.validateLocker();
		this.getAllLocation();
	}

	askToChange() {
		if (!this.model.status) {
			this.model.status = !this.model.status
			this.Modal.confirm({
				header: this.$translate.instant(`${this.pageName}.suspend_${this.pageName}`),
				message: this.$translate.instant(`${this.pageName}.suspend_${this.pageName}_message`),
				callback: ({
					modal,
					$scope
				}) => {
					this.model.status = !this.model.status
					modal.close()
				},
				negative: ({
					modal,
					$scope
				}) => {
					modal.close()
				},
				type: 'danger',
				buttons: ['common.yes', 'common.no']
			})
		}
	}

	submit(evt) {
		this.loading = true;
		let truckLockers = this.vehicleLockerData();

		this.Service.update(this.rawId, {
			id: this.model.id,
			locationId: this.model.locationId.Value,
			make: this.model.make,
			status: this.model.status,
			model: this.model.model,
			year: this.model.year,
			vinnum: this.model.vinnum,
			platenum: this.model.platenum,
			lockers: this.model.lockers,
			truckLockers: truckLockers.map((info) => {
				if (this.model.liability) info.maxShipment = null;
				else info.maxLiability = null;
				return info;
			}),
			liability: this.model.liability,
			liabilityLimit: this.model.liabilityLimit,
			truckLiability: this.model.truckLiability,
			NFCScan: this.model.NFCScan,
			NFCTagId: this.model.NFCScan ? this.model.NFCTagId : null,
			fuelType: this.model.fuelType
		}, this.branch)
			.then((data) => {
				this.loading = false;
				window.history.go(-1)
			})
			.catch((err) => {
				this.loading = false;
				const errorPath = err && err.data && err.data.errors && err.data.errors[0].path;

				if (errorPath === 'VEHICLE.NFCTagId') {
					this.errorMessage = this.$translate.instant('common.unique_nfc_tag_id');
				}
				else if (err && err.data && err.data.message) {
					this.errorMessage = err.data.message;
				}
				else if (err && err.data && err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
			})
	}

	locationSearchObj(searchKey) {
		searchKey = searchKey || '';
		const searchObj = {
			queryJSON: {
				rules: [{
					field: 'branchId',
					condition: '=',
					data: this.branch
				},
				{
					field: 'locationType',
					condition: '=',
					data: 'LOCKER'
				},
				{
					group: {
						rules: [{
							field: 'id',
							condition: 'like',
							data: '%' + searchKey + '%'
						},
						{
							field: 'name',
							condition: 'like',
							data: '%' + searchKey + '%'
						}
						],
						operator: 'OR'
					}
				}
				],
				operator: 'AND'
			}
		};
		return searchObj.queryJSON.rules.length ? searchObj : null;
	}

	getLockerLocations(searchKey, offset) {
		// var searchObj = this.locationSearchObj(searchKey);
		searchKey = searchKey || null;
		return this.VehicleLockerService.getLockerLocations(this.locationIds, searchKey, this.branch, AppConstants.defaultPageLimit, offset)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.totalLocations = data.total;
					this.lockerLocations = this.locationMap(data.results, searchKey, null);
				} else {
					const loc = this.locationMap(data.results, searchKey, null);
					this.lockerLocations = this.lockerLocations.concat(loc);
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.errorMessage = err.data.message;
				}
			})
	}

	loadLockerLocations(searchKey, offset, index) {
		// var searchObj = this.locationSearchObj(searchKey);
		searchKey = searchKey || null;
		if (offset !== 0 && this.model.truckLockers && !searchKey && Math.abs(offset % 2) == 1) {
			offset = offset - 1;
		}
		return this.VehicleLockerService.getLockerLocations(this.locationIds, searchKey, this.branch, AppConstants.defaultPageLimit, offset)
			.then((data) => {

				let selectedVal = this.model.truckLockers[index].location ? this.model.truckLockers[index].location.Value : '';
				let location = this.model.truckLockers[index].location ? this.model.truckLockers[index].location.Key : ''

				if (offset === 0) {
					this.model.truckLockers[index].totalLocations = data.total;
					this.model.truckLockers[index].lockerLocations = this.locationMap(data.results, searchKey, selectedVal);
					if (!searchKey && selectedVal && location) {
						this.model.truckLockers[index].lockerLocations.unshift({
							Key: location,
							Value: selectedVal
						});
					}
				} else {
					const loc = this.locationMap(data.results, searchKey, selectedVal);
					this.model.truckLockers[index].lockerLocations = this.model.truckLockers[index].lockerLocations.concat(loc);
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.errorMessage = err.data.message;
				}
			})
	}

	locationMap(locations, searchKey, originalVal) {
		let data = [];
		locations.map((obj) => {
			obj.Key = obj.locationId + ' | ' + obj.locationName;
			obj.Value = obj.locationId;

			if (!searchKey && originalVal) {
				if (obj.Value !== originalVal) {
					data.push(obj);
				}
			} else {
				data.push(obj);
			}
		});
		return data;
	}

	addTruckLockers(searchKey, offset) {
		// var searchObj = this.locationSearchObj('');
		searchKey = searchKey || null;
		this.isLoading = true;

		this.VehicleLockerService.getLockerLocations(this.locationIds, searchKey, this.branch, AppConstants.defaultPageLimit, offset)
			.then((data) => {
				let lockerLocations = this.locationMap(data.results, '', null);
				this.model.truckLockers.push({
					label: null,
					maxShipment: 1,
					maxLiability: null,
					location: null,
					locationId: null,
					isDuplicate: false,
					totalLocations: data.total,
					lockerLocations: lockerLocations,
					sequence: this.model.truckLockers.length + 1,
					status: 'Create'
				});
				if (this.model.truckLockers.length > 1) {
					this.validateLocker();
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.errorMessage = err.data.message;
				}
			})
			.finally(() => {
				this.isLoading = false;
			})
	}

	removeLockers(index) {
		if (this.model.truckLockers[index].id) {
			this.model.truckLockers[index].status = 'Delete';
			this.itemsToDelete.push(this.model.truckLockers[index]);
		}
		this.model.truckLockers.splice(index, 1);
		this.validateLocker();
	}

	validateLocker() {
		this.model.truckLockers = _.map(this.model.truckLockers, (obj, index) => {
			obj.isDuplicate = false;
			obj.locationId = obj.location ? obj.location.Value : null;
			let match = _.find(this.model.truckLockers, (compairObject, compairObjIndex) => {
				compairObject.locationId = compairObject.location ? compairObject.location.Value : null;
				if (index > compairObjIndex) return compairObject.locationId == obj.locationId;
			});
			if (match) {
				obj.isDuplicate = true;
				return obj;
			} else {
				return obj;
			}
		});
		let isValidDirective = this.model.truckLockers.map((obj) => {
			if (obj.isDuplicate) return true;
		})
		this.isValid = isValidDirective.indexOf(true) >= 0 ? false : true;
	}

	vehicleLockerData() {
		let data = [];
		if (this.model.truckLockers.length) {
			this.model.truckLockers.forEach((info) => {
				data.push({
					id: info.id ? info.id : null,
					label: info.label,
					maxShipment: info.maxShipment,
					maxLiability: info.maxLiability,
					locationId: info.locationId,
					sequence: info.sequence,
					status: info.status
				})
			})
		}
		if (this.itemsToDelete.length) {
			this.itemsToDelete.forEach((info) => {
				data.push({
					id: info.id,
					label: info.label,
					maxShipment: info.maxShipment,
					maxLiability: info.maxLiability,
					locationId: info.locationId,
					sequence: info.sequence,
					status: info.status
				})
			})
		}
		return data.filter(this.getDifference(this.defaultLockers));
	}

	getDifference(defaultLockers) {
		return function (current) {
			return defaultLockers.filter(function (previous) {
				return previous.label == current.label && previous.locationId == current.locationId
					&& previous.maxShipment == current.maxShipment && previous.maxLiability == current.maxLiability
					&& current.status != 'Delete'
			}).length == 0;
		}
	}

	lockerInfo() {
		return this.getLockerLocations('', 0)
			.then(() => {
				if (this.model.truckLockers.length) {
					this.model.truckLockers.map((loc, index) => {
						loc.location = {
							Key: loc.location.id + " | " + loc.location.name,
							Value: loc.location.id
						}
						loc.totalLocations = this.totalLocations;
						loc.lockerLocations = this.locationMap(this.lockerLocations, '', loc.location.Value);
						loc.lockerLocations.unshift(loc.location);
						loc.duplicate = false;
						loc.status = 'Update';
						return loc;
					})
					this.defaultLockers = JSON.parse(JSON.stringify(this.model.truckLockers));
				}
			})
	}

	resetLockers() {
		if (!this.model.lockers) {
			return this.Service.get(this.$stateParams.id)
				.then((data) => {
					this.model.truckLockers = data.truckLockers;
					this.lockerInfo().then(() => this.validateLocker());
				})
		}
	}

	validateLiability() {
		if (!this.model.truckLiability || !this.model.liability) return;

		let lockerLiability = 0;
		this.isLiabilityExceed = false;
		this.liabilityError;

		this.model.truckLockers.forEach((locker, index) => {
			lockerLiability += locker.maxLiability;
		})
		if (this.model.liabilityLimit && (lockerLiability > this.model.liabilityLimit)) {
			this.isLiabilityExceed = true;
			this.liabilityError = this.$translate.instant('truck.liability_error');
		}
		else {
			this.isLiabilityExceed = false;
			delete this.liabilityError;
		}
	}

	resetLiability() {
		if (!this.model.truckLiability) this.model.liabilityLimit = null;
	}

}

export default TruckEditController;


// WEBPACK FOOTER //
// ./client/app/components/truck/edit/truck.edit.controller.js